module.exports = __webpack_public_path__ + "img/explain_ellipse_white.7627e808.svg";